import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import axios from 'axios';
import {
    Button,
    Container,
    Paper,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import "./AddEmployeeForm.css";
import "./AddInputForm.css"

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const AddNewInputTypeFormForAll = ({onAdd}) => {
    const query = useQuery();
    const caseId = parseInt(query.get("id"), 10);
    const [inputTypes, setInputTypes] = useState([]);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [descriptionDropDown, setDescriptionDropDown] = useState('');
    const [isRequired, setIsRequired] = useState(false);
    const [isInternal, setIsInternal] = useState(false);
    const [isInternalDropDown, setIsInternalDropDown] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [deleteInputTypeId, setDeleteInputTypeId] = useState(null);
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const [isEditing, setIsEditing] = useState(null);
    const [editableInputType, setEditableInputType] = useState({
        name: '',
        description: '',
        required: false,
        internal: false,
        integration: false,
    });

    const [dictionaryTypes, setDictionaryTypes] = useState([]);
    const [isDropdownModalOpen, setIsDropdownModalOpen] = useState(false);
    const [selectedType, setSelectedType] = useState({});
    const [isDropdownRequired, setIsDropdownRequired] = useState(false);
    const [draggedItem, setDraggedItem] = useState(null);
    const [droppedItem, setDroppedItem] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);
    const [inputType, setInputType] = useState('0');
    const [integration, setIntegration] = useState(false);
    const handleDragEnter = (e, index) => {
        const row = e.currentTarget;
        if (row && draggedItem !== index) {
            row.style.backgroundColor = "#d0e0f0";
        }
    };





    const confirmDropdownSubmit = async () => {
        if (!selectedType.id) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
            setIsDropdownModalOpen(false);
            return;
        }

        const newSortValue = inputTypes.length + 1; // New sort value

        const newDropdownInputType = {
            name: selectedType.typesName,
            value: selectedType.id.toString(),
            type: 1,
            required: isDropdownRequired,
            categoryId: 40,
            sort: newSortValue,
            description: descriptionDropDown,
            internal: isInternalDropDown
        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CreateGlobalInputTypes`, newDropdownInputType);
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა!', type: 'success'});
            clearForm();
            await fetchInputTypes(); // Fetch the updated list to reflect the new addition
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
        } finally {
            setIsDropdownModalOpen(false);
        }
    };

    const refreshInputTypes = () => {
        fetchInputTypes();
    };
    useEffect(() => {
        fetchDictionaryTypes();
    }, []);

    const fetchDictionaryTypes = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryTypes`);
            setDictionaryTypes(response.data.data);
        } catch (error) {
        }
    };

    useEffect(() => {
        fetchInputTypes();
    }, [caseId]);


    const clearForm = () => {
        setName('');
        setDescription('')
        setDescriptionDropDown('')
        setIsRequired(false);
        setIsInternal(false);
    };

    const openSubmitModal = (e) => {
        e.preventDefault();
        setIsModalOpen(true);
    };

    const confirmSubmit = async () => {
        const newSortValue = inputTypes.length + 1;

        const newInputType = {
            name: name,
            value: "",
            type: parseInt(inputType, 10),
            required: isRequired,
            caseId: caseId,
            sort: newSortValue,
            integration: integration ? 1 : 0,
            description: description,
            internal: isInternal
        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CreateGlobalInputTypes`, newInputType);
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა!', type: 'success'});
            clearForm();
            fetchInputTypes();
            onAdd()
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
        } finally {
            setIsModalOpen(false);
        }
    };


    const fetchInputTypes = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllGlobalInputTypes?PageSize=1000&Page=0`);
            const filteredAndSortedInputTypes = response.data.data.result.sort((a, b) => a.sort - b.sort);
            setInputTypes(filteredAndSortedInputTypes);
        } catch (error) {
        }
    };


    const handleEdit = (inputType) => {
        setIsEditing(inputType.id);
        setEditableInputType({
            ...inputType,
            description: inputType.description,
            internal: inputType.internal,
            required: inputType.internal ? false : inputType.required,
        });
    };

    const cancelEdit = () => {
        setIsEditing(null);
        setEditableInputType({
            name: '',
            description: '',
            required: false,
            internal: false,
            integration: false,
        });
    };
    const handleSave = async (inputTypeId) => {
        const updatedInputType = {
            ...editableInputType,
            id: inputTypeId,
            caseId: caseId,
            description: editableInputType.description,
            internal: editableInputType.internal,
            integration: editableInputType.integration,
        };

        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditGlobalInputTypes`, updatedInputType);
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'});
            fetchInputTypes();
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
        } finally {
            setIsEditing(null);
        }
    };

    const openDeleteModal = (inputTypeId) => {
        setDeleteInputTypeId(inputTypeId);
        setIsDeleteModalOpen(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteGlobalInputTypes`, {id: deleteInputTypeId});
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა!', type: 'success'});

            const remainingInputTypes = inputTypes.filter(inputType => inputType.id !== deleteInputTypeId);

            remainingInputTypes.sort((a, b) => a.sort - b.sort);

            for (let i = 0; i < remainingInputTypes.length; i++) {
                if (remainingInputTypes[i].sort !== i + 1) {
                    const updatedInputType = {
                        ...remainingInputTypes[i],
                        sort: i + 1,
                    };

                    await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditGlobalInputTypes`, updatedInputType);

                    remainingInputTypes[i].sort = i + 1;
                }
            }

            setInputTypes(remainingInputTypes);

        } catch (error) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
        } finally {
            setIsDeleteModalOpen(false);
        }
    };




    const isSubmitDisabled = name.trim() === '';

    return (
        <div className="add-dov-type-form">
            <Container style={{marginTop: "100px"}}>
                <Paper>
                    <form
                          onSubmit={openSubmitModal}>
                        <div className={"add-form-container"}>
                        <div className={""}>

                            <div className={"add-form-input-title"}>შესაყვანი ველის დამატება</div>
                            <TextField
                                label="სახელი"
                                fullWidth
                                margin="normal"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />


                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                style={{marginTop: 16}}
                                disabled={isSubmitDisabled}
                            >
                                დამატება
                            </Button>
                        </div>
                        </div>

                    </form>

                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align={"right"}>სახელი</TableCell>
                                    <TableCell align={"right"}>ქმედება</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {inputTypes.map((inputType, index) => (
                                    <TableRow

                                        key={inputType.id}
                                        className={`${draggedItem === index ? "row-being-dragged" : ""} ${droppedItem === index ? "row-dropped" : ""} ${dragOverIndex === index ? "drag-over" : ""}`}
                                    >
                                        <TableCell align={"right"}>
                                            {isEditing === inputType.id ? (
                                                <TextField
                                                    value={editableInputType.name}
                                                    onChange={(e) => setEditableInputType({
                                                        ...editableInputType,
                                                        name: e.target.value
                                                    })}
                                                    fullWidth
                                                />
                                            ) : (
                                                inputType.name
                                            )}
                                        </TableCell>






                                        <TableCell align={"right"}>
                                            {isEditing === inputType.id ? (
                                                <>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => handleSave(inputType.id)}
                                                        style={{marginRight: 10}}
                                                    >
                                                        შენახვა
                                                    </Button>
                                                    <Button
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={cancelEdit}
                                                    >
                                                        გაუქმება
                                                    </Button>
                                                </>
                                            ) : (
                                                <>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => handleEdit(inputType)}
                                                        disabled={isEditing != null}
                                                    >
                                                        რედაქტირება
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="error"
                                                        onClick={() => openDeleteModal(inputType.id)}
                                                        style={{marginLeft: '10px'}}
                                                        disabled={isEditing != null}
                                                    >
                                                        წაშლა
                                                    </Button>
                                                </>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </Paper>

            </Container>
            <ConfirmationModal
                isOpen={isDeleteModalOpen}
                onRequestClose={() => setIsDeleteModalOpen(false)}
                onConfirm={handleDeleteConfirm}
            />
            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }

            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={confirmSubmit}
            />
            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }
            <ConfirmationModal
                isOpen={isDropdownModalOpen}
                onRequestClose={() => setIsDropdownModalOpen(false)}
                onConfirm={confirmDropdownSubmit}
            />

            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }
        </div>
    );
};

export default AddNewInputTypeFormForAll;